import { Component, input, ViewEncapsulation } from '@angular/core';

export type TooltipPosition = 'above' | 'below' | 'left' | 'right';

@Component({
  selector: 'app-html-tooltip',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div
      class="html-tooltip"
      [class.above]="position() === 'above'"
      [class.below]="position() === 'below'"
      [class.left]="position() === 'left'"
      [class.right]="position() === 'right'"
      [innerHTML]="content()"
    ></div>
  `,
  styles: [
    `
      .html-tooltip {
        position: relative;
        background-color: white;
        border-radius: 4px;
        color: #333;
        font-family: Roboto, 'Helvetica Neue', sans-serif;
        font-size: 12px;
        padding: 10px;
        max-width: 250px;
        word-wrap: break-word;
        filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));

        p,
        ul,
        h4 {
          margin: 0 0 4px 0;
          padding-left: 0;
        }
        p:last-child,
        ul:last-child {
          margin: 0;
        }
      }

      .html-tooltip::after {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 6px;
      }

      /* Tooltip ABOVE: Arrow points DOWN at bottom center */
      .html-tooltip.above::after {
        top: 100%;
        left: 50%;
        margin-left: -6px;
        border-color: white transparent transparent transparent;
      }

      /* Tooltip BELOW: Arrow points UP at top center */
      .html-tooltip.below::after {
        bottom: 100%;
        left: 50%;
        margin-left: -6px;
        border-color: transparent transparent white transparent;
      }

      /* Tooltip RIGHT: Arrow points LEFT at center left */
      .html-tooltip.right::after {
        top: 50%;
        right: 100%;
        margin-top: -6px;
        border-color: transparent white transparent transparent;
      }

      /* Tooltip LEFT: Arrow points RIGHT at center right */
      .html-tooltip.left::after {
        top: 50%;
        left: 100%;
        margin-top: -6px;
        border-color: transparent transparent transparent white;
      }
    `,
  ],
})
export class HtmlTooltipComponent {
  content = input<string>('');
  position = input<TooltipPosition>('above');
}
